import Stack, { StackProps } from 'src/app/atoms/Layout/Stack/Stack';
import { cssVar } from 'src/app/styles/helper';
import styled, { css } from 'styled-components';

interface PriceBlockContainerProps extends StackProps {
  $minHeight?: number;
}

export const PriceBlockContainer = styled(Stack)<PriceBlockContainerProps>`
  border-bottom: 1px solid ${cssVar('border-secondary')};
  height: fit-content;

  ${({ $minHeight }) =>
    $minHeight &&
    css`
      min-height: ${$minHeight}px;
    `}

  .period {
    margin-bottom: ${cssVar('spacing-xl')};
  }
`;
